/* eslint-disable no-unused-vars */
// @ts-nocheck
import React, { useState } from "react";
import { BlobProvider, pdf, PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { PdfDocument } from "./PdfDocument";
import { DownloadLink } from "@sia/style-guide";
import { saveAs } from "file-saver";
import { fetchAllExperts } from "./helper";
export default function PdfDocumentLink({ selectedFilters, chosenSortItem, memberType, language, pdfData, translate }) {
  const onClick = async (e) => {
    e.preventDefault();
    const allExpertsData = await fetchAllExperts(selectedFilters, chosenSortItem, memberType, language);
    let today = new Date();
    let dateString = today.toLocaleDateString("de-CH", { year: "numeric", month: "2-digit", day: "2-digit" });
    let generationDateString = today.toLocaleDateString("de-CH", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
    const fileName = translate("directory.pdf.file-name", { date: dateString });
    const blob = await pdf(<PdfDocument pdfData={allExpertsData} translate={translate} generationDateString={generationDateString} />).toBlob();
    saveAs(blob, fileName);
  };
  return <DownloadLink onClick={onClick} text={translate("directory.pdf.generate")} />;
}
